import React from "react"
import * as styles from "./map-headline.module.scss"
import { fromPairs } from 'lodash'
import classNames from 'classnames';
import { useImage } from '../hooks/useImage'

export default function MapHeadline(props) {
    const image = useImage(props.image)
    return (
        <div className={styles.headline} >
            {(image) && <span className={styles.imageContainer}><img className={styles.image} src={image.publicURL} /></span>}       
            <span>{props.headline}</span>
        </div>
    )
}